import React from 'react';
import Select from 'react-select';
import { Spinner } from 'react-bootstrap';
import { formService } from '../../_services/form.service';
import { useEffect, useState } from 'react';

export default function PreVisitQuestionOption({ defaultValue, handleSelected, disabled = false, textDark = false }) {
  const [preVisitQuestionOptions, setPreVisitQuestionOptions] = useState([]);
  const [preVisitQuestionsSelected, setPreVisitQuestionsSelected] = useState("");

  useEffect(() => {
    setPreVisitQuestionsSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    formService.getAllForms('Telehealth')
      .then((forms) => {
        setPreVisitQuestionOptions(
          forms.map((form) => {
            return { value: form.id, label: form.title };
          })
        )
      });
  }, [])

  if (preVisitQuestionOptions.length === 0) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }

  const preVisitQuestionOptionSelected = preVisitQuestionOptions.find((form) => {
    return form.value === preVisitQuestionsSelected;
  });

  return (
    <Select
      placeholder='By Questions'
      isClearable={true}
      options={preVisitQuestionOptions}
      onChange={selected => {
        if (selected) {
          setPreVisitQuestionsSelected(selected.value);
          handleSelected(selected.value, selected.label);
        } else {
          setPreVisitQuestionsSelected('');
          handleSelected('', '');
        }
      }}
      isDisabled={disabled}
      styles={textDark && {
        singleValue: (styles) => {
          return {
            ...styles, color: 'black',
          };
        },
      }}
      value={preVisitQuestionOptionSelected || ''}
    />
  )
}
